export function setLanguage(language = "en") {
	localStorage.setItem("lan", JSON.stringify(language));
}

export function getLanguage() {
	try {
		const lan = localStorage.getItem("lan");
		if (!lan) {
			setLanguage("en");
			return "en";
		}
		return JSON.parse(lan);
	} catch (error) {
		setLanguage("en");
		return "en";
	}
}
